// extracted by mini-css-extract-plugin
export default {"cls1":"MCuLft5PEaKyUJSza_9L","cls2":"wsLEeAuAUHP8nGoq0naS MCuLft5PEaKyUJSza_9L"};